/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://4be8098xq9.execute-api.eu-central-1.amazonaws.com/testeuc",
            "region": "eu-central-1"
        },
        {
            "name": "SspBackendApi",
            "endpoint": "https://tw691as8hi.execute-api.eu-central-1.amazonaws.com/testeuc",
            "region": "eu-central-1"
        },
        {
            "name": "SspExternalApi",
            "endpoint": "https://e9g5o50ty6.execute-api.eu-central-1.amazonaws.com/testeuc",
            "region": "eu-central-1"
        },
        {
            "name": "bpmnGen",
            "endpoint": "https://8i3rbxyd0j.execute-api.eu-central-1.amazonaws.com/testeuc",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:2cdb6f87-c22e-4bae-bb71-cbebe8fd51b8",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_7RsUC52nW",
    "aws_user_pools_web_client_id": "1t80qs1951ca7b3vuaq3b4l1td",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "selfserviceportal-20240129105819-hostingbucket-testeuc",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "https://d2o93a5x0t8bud.cloudfront.net",
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "SspUserInfo_testeuc1",
            "region": "eu-central-1"
        }
    ]
};


export default awsmobile;
